export const DataModelType = {
  BannerDTO: 'BannerDTO',
  CollectionDTO: 'CollectionDTO',
  ItpDTO: 'ItpDTO',
  NewsletterDTO: 'NewsletterDTO',
  OffPlatformDTO: 'OffPlatformDTO',
  PageDTO: 'PageDTO',
  MultiCollectionDTO: 'MultiCollectionDTO'
} as const;

export type DataModelTypeKeys = keyof typeof DataModelType;

export const EntityType = {
  Article: 'Article',
  Collection: 'Collection',
  Issue: 'Issue',
  LinkedItem: 'LinkedItem',
  List: 'List',
  MultiList: 'MultiList',
  Module: 'Module',
  Page: 'Page',
  Query: 'Query',
  Section: 'Section',
  Group: 'Group'
} as const;
